import { APICallV1 } from 'reactApp/api/APICall';

export class ExtraEmailAddAPICall extends APICallV1 {
    _method = 'profile/attach_email';
    _type = 'post';
    defaultData = this._defaultPayload;
}
